import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const token = (document.querySelector("[name='__RequestVerificationToken']") as HTMLInputElement)?.value;

    if (token) {
        const cloned = req.clone({
            setHeaders: {
                'RFT': token,
                'X-Requested-With': 'XMLHttpRequest'
            }
        });
        return next(cloned);
    }

    return next(req);
};
